import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils";

import type { I18nT } from "@lib/dashboardI18n";

const SegmentCohortsForNro = lazy(() =>
  import("@scenes/PlgLandingPage/LandingPages/NavigationRouting/SegmentCohortsForNro").then((module) => ({
    default: module.SegmentCohortsForNro,
  }))
);

export const segmentCohortsNRO: NavigationRoutingObject = {
  Component: SegmentCohortsForNro,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "audience",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("segment-extensions-sidebar-pill-menu-option", "Segment Extensions"),
  pageNameForTracking: () => "Segment Extensions",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "segment-extensions-description-nav",
      "Target audiences based on specific behaviors over longer periods of time"
    ),
  icon: "nav-system-segment-extensions",
  featureLimitationKeys: ["can_only_view_landing_page_segment_extensions"],
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: (t: I18nT<"dashboard-navigation">) => ({
    segment_cohorts: makeAdditionalSearchableFeature({
      heading: t("segment-extensions-sidebar-pill-menu-option", "Segment Extensions"),
      pathname: "/engagement/segment_cohorts/:segmentCohortId/:appGroupId",
      query: { segmentCohortId: "segment_cohorts" },
      description: t(
        "segment-extensions-description-nav",
        "Target audiences based on specific behaviors over longer periods of time"
      ),
      additionalSearchTerms: [
        {
          keywords: [t("segment-extensions-alt-keyword-1", "SQL Credit")],
        },
      ],
    }),
  }),
  defaultRoute: "/engagement/segment_cohorts/segment_cohorts/:appGroupId",
};
